import axios, { AxiosError } from "axios";
import { HttpGetClient } from "../../data/http-client/http-get-client";
import { HttpPostClient } from "../../data/http-client/http-post-client";

export class AxiosHttpClient<RequestType, ResponseType> implements
  HttpGetClient<RequestType, ResponseType>,
  HttpPostClient<RequestType, ResponseType> {
  async get (params: HttpGetClient.Params<RequestType>): Promise<HttpGetClient.Result<ResponseType>> {
    try {
      const response = await axios.get(params.url)
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      if (!axiosError.response) return {
        data: axiosError.message as ResponseType,
        status: 0
      }
      return {
        data: axiosError.response.data as ResponseType,
        status: axiosError.response.status
      }
    }
  }
  async post (params: HttpPostClient.Params<RequestType>): Promise<HttpPostClient.Result<ResponseType>> {
    try {
      const response = await axios.post(params.url, params.data, { headers: params.headers })
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      if (!axiosError.response) return {
        data: axiosError.message as ResponseType,
        status: 0
      }
      return {
        data: axiosError.response.data as ResponseType,
        status: axiosError.response.status
      }
    }
  }
}